import { AppInsightsContext } from '@shared/components/AppTelemetry/AppTelemetryProvider';
import { useContext, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Helmet } from 'react-helmet-async';

// This page is meant to create a cookie that will opt-out the user of targeting advertising
// It's called from the retail privacy policy page
export default function OptOutPage() {
    const { logPageView } = useContext(AppInsightsContext);
    const [cookies, setCookie] = useCookies(['KmxOptOut']);

    useEffect(() => {
        logPageView('Opt-Out');
    }, [logPageView]);

    // Value and expiry date come from retail
    const expiryDate = new Date('2038-01-01');
    if (!cookies.KmxOptOut) {
        setCookie('KmxOptOut', expiryDate.toString(), {
            domain: '.carmaxauctions.com',
            expires: expiryDate,
            sameSite: 'strict',
        });
    }
    window.close();

    return (
        <>
            <Helmet>
                <title>Opt-out Marketing Page</title>
            </Helmet>
            <main style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <h1>Success! Your information is no longer being shared for value.</h1>
                <div>You may now close this window</div>
            </main>
        </>
    );
}
